const organization = {
  organizations: 'Accounts',
  search_organization: 'Search Accounts',
  add_organization: 'New Account',
  controllers: 'Controllers',
  organization: 'Account',
  payment_methods: 'Payment methods',
  name_on_card: 'Name on card',
  card_number: 'Card number',
  expiration_date: 'Expiration date',
  is_default: 'Make as default',
  expires_at: 'Card expiry date',
  select_organization_msg: 'Please go to accounts and select one',
  summary: 'Summary',
  single_site: 'Single site',
  table: {
    company: 'COMPANY',
    full_name: 'FULL NAME',
    email: 'EMAIL',
    country: 'COUNTRY',
    address: 'ADDRESS',
    status: 'STATUS',
    site: 'SITE',
    organization: 'ACCOUNT',
    firmware_version: 'FIRMWARE VERSION',
  },
  form: {
    secondContact: 'Second contact',
    create_admin: 'Create an Administrator user',
    main_contact_first_name: 'Main Contact - First Name',
    main_contact_last_name: 'Main Contact - Last Name',
    second_contact_first_name: 'First Name',
    second_contact_last_name: 'Last Name',
  },
  information: {
    website: 'Website',
    region: 'Region',
  },
  modal: {
    delete_payment_description: 'Are you sure to delete this card',
  },
  set_multisite_msg:
    "Are you sure you want to change <b style={{color: 'blue'}}>{{name}} from Single Site to</b> <b style={{color: 'green'}}>Multiple Sites</b>",
  set_singlesite_msg:
    "Are you sure you want to change <b style={{color: 'blue'}}>{{name}} from Multiple Sites to</b> <b style={{color: 'green'}}>Single Site</b>",
};

export default organization;
